import { useMutation } from "@tanstack/react-query";
import { updatePartnerSettings } from "../api/AdminCustomersApi";
import { useAuth } from "../../../../Context/AuthContext";
import { SuccessMessage, ErrorMessage } from "../../../../utils/toastify";

export const useUpdatePartnerSettings = (onClose, refetch) => {
  const auth = useAuth();
  const user = auth.getSessionData();
  return useMutation({
    mutationKey: ["updatePartnerSettings"],
    mutationFn: async ({ data }) => {
      const { channels, uid_partner } = data;

      const data_to_submit = {
        id: uid_partner,
        isSms: channels.includes("SMS"),
        isEmail: channels.includes("Email"),
        isWhatsapp: channels.includes("WhatsApp"),
        isRcs: channels.includes("RCS"),
      };

      return await updatePartnerSettings({
        data: data_to_submit,
        token: user.token,
      });
    },
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Error al cambiar los canales");
        return;
      }

      SuccessMessage("Operación exitosa: se actualizaron los canales");
      refetch();
      onClose();
    },
    onError: () => {
      ErrorMessage("Ha ocurrido un error");
    },
  });
};
